import request from '@/plugin/axios'

export function getFlowmainstatisticsList(pageable) {
    return request({
        url: '/api/admin/queryStatisticsData',
        method: 'get',
        params: pageable
    })
}